<template>
  <div class="flex justify-center w-full h-auto p-5 text-gray-800">
    <div class="w-full max-w-lg bg-white border rounded border-gray-200 shadow-sm px-5 py-7">
      <div v-if="success" class="text-center space-y-4">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 mx-auto text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <h2 class="text-2xl font-bold text-gray-800">Sucesso!</h2>
        <p class="text-gray-600">Link de acesso enviado para o seu email.</p>
      </div>

      <div v-else>
        <h2 class="text-2xl font-bold mb-6 text-center text-gray-800">Solicitar Acesso</h2>

        <form @submit.prevent="submitRequest" class="space-y-6">
          <div>
            <label for="email" class="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input
              id="email"
              type="email"
              v-model="email"
              required
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:border-transparent transition-colors duration-200"
              :style="{ '--tw-ring-color': themeColor, 'caret-color': themeColor }"
              placeholder="seu@email.com"
            />
          </div>

          <button
            type="submit"
            :disabled="loading"
            class="w-full text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed transition duration-200 hover:opacity-90"
            :style="{ backgroundColor: themeColor, '--tw-ring-color': themeColor }"
          >
            <span v-if="loading">Enviando...</span>
            <span v-else>Confirmar</span>
          </button>
        </form>

        <div v-if="error" class="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded text-sm text-center">
          {{ error }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { requestAccess } from '@/repositories/integrations/mobly/services/csExternal/lead'
import { MOBLY, TOKSTOK, SUPPORT } from '@/utils/possible-organizations-values'

export default {
  name: 'ExternalRequestAccess',
  data () {
    return {
      email: '',
      loading: false,
      success: false,
      error: '',
      organization: MOBLY
    }
  },
  computed: {
    themeColor () {
      switch (this.organization) {
        case TOKSTOK:
          return '#0a775a'
        case SUPPORT:
          return '#000000'
        case MOBLY:
        default:
          return '#ff4600'
      }
    }
  },
  created () {
    this.setOrganizationBasedOnDomain()
  },
  methods: {
    setOrganizationBasedOnDomain () {
      const currentHost = window.location.hostname
      console.log(currentHost)
      const tokstokDomain = process.env.VUE_APP_DOMAIN_TOKSTOK
      const supportDomain = process.env.VUE_APP_DOMAIN_SUPPORT

      if (currentHost.includes(tokstokDomain)) {
        this.organization = TOKSTOK
      } else if (currentHost.includes(supportDomain)) {
        this.organization = SUPPORT
      } else {
        this.organization = MOBLY
      }
    },

    async submitRequest () {
      this.loading = true
      this.error = ''

      try {
        await requestAccess(this.email, this.organization)
        this.success = true
      } catch (err) {
        if (err.response && err.response.status === 404) {
          this.error = 'Solicite o acesso com um administrador pois o seu cadastro não existe.'
        } else {
          this.error = 'Ocorreu um erro ao processar sua solicitação. Tente novamente mais tarde.'
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
